"use client";

import type { PromotionRewardType } from "~/types";
import { Box } from "../Box/Box";
import { Button } from "../Button/Button";
import { LottieIcon, type LottieIconName } from "../LottieIcon";
import { Modal } from "../Modal/Modal";
import { Stack } from "../Stack/Stack";
import { Text } from "../Text/Text";

export function ClaimSuccessModal(props: {
  rewardType?: PromotionRewardType | null;
  collectionDescription?: string | null;
  onClose(): void;
  open?: boolean;
}) {
  const [heading, subtitle] = defaultCompletionHeadingAndSubtitle(
    props.rewardType,
  );

  const iconName = getIconNameForReward(props.rewardType);

  return (
    <Modal
      open={props.open === undefined || Boolean(props.open)}
      onClose={props.onClose}
      hideHeader
      footer={
        <Button primary onClick={props.onClose}>
          Continue
        </Button>
      }
      removeGutter
    >
      <Box
        display="flex"
        flexDirection="column"
        width="full"
        height="full"
        justifyContent={"flexEnd"}
        overflow="hidden"
      >
        <Box
          width="full"
          style={{
            aspectRatio: "1",

            position: "relative",
          }}
          flexShrink={0}
        >
          {/* Background image goes in this element */}
          <Box
            className="post-redemption-bg"
            background="neutral-200"
            style={{ zIndex: -1, aspectRatio: "1" }}
            width="full"
          />
          <Box
            width="full"
            position="absolute"
            style={{
              top: "0",
              aspectRatio: "1",
            }}
            justifyContent={"flexEnd"}
            display="flex"
            flexDirection={"column"}
          >
            {/* Background arc */}
            <Box
              id="background-arc"
              background="primary"
              style={{
                height: "16.5%",
                clipPath: "ellipse(60% 100% at 50% 100%)",
              }}
            />
          </Box>
          <Box
            width="full"
            position="absolute"
            style={{
              top: "0",
              aspectRatio: "1",
              zIndex: 1,
            }}
            display="flex"
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Box
              background="white"
              borderRadius="full"
              position="absolute"
              style={{
                width: "33%",
                padding: "5%",
                marginTop: "66%",
                height: "33%",
              }}
            >
              <LottieIcon iconName={iconName} color="primary" loop autoPlay />
            </Box>
          </Box>
        </Box>

        <Box
          background="primary"
          padding="3"
          paddingBottom="7"
          textAlign="center"
          flexGrow={1}
        >
          <Box display="flex" flexDirection={"column"}>
            <Box paddingY="4">
              <Stack space="8">
                <Text size="xxlarge" weight="strong" color="overPrimary">
                  {heading}
                </Text>
                <Text color="overPrimary">{subtitle}</Text>
              </Stack>
            </Box>
            <Box flexGrow={1}>
              {(props.collectionDescription?.split("\n") || []).map(
                (t, key) => (
                  <Text key={key} color="overPrimary">
                    {t}
                  </Text>
                ),
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

function defaultCompletionHeadingAndSubtitle(
  rewardType?: PromotionRewardType | null,
): [string, string] {
  switch (rewardType) {
    case "LIST":
      return ["Congratulations!", "You have scored."];
    case "POINTS":
      return ["Congratulations!", "Points have been added to your account."];
    case "CREDIT":
      return ["Nice one!", "Credit has been added to your account."];
    case "DISCOUNT":
      return ["What a score!", "You have a discount coming your way."];
    default:
      return [
        "Congratulations!",
        "You've successfully redeemed this promotion.",
      ];
  }
}

function getIconNameForReward(
  rewardType?: PromotionRewardType | null,
): LottieIconName {
  switch (rewardType) {
    default:
    case "POINTS":
      return "points-icon";
    case "CREDIT":
      return "credit-icon";
    case "DISCOUNT":
      return "discount-icon";
    case "LIST":
      return "add-to-list-icon";
  }
}
